/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Choice/view.blocks to change it.
import Options from './Options/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Choice({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/Choice"
  
}) {
  return (<React.Fragment
>
<Options
  viewPath={`${viewPath}/Options`}
/>
{children}
</React.Fragment>)
}